const Docs = () => import(/* webpackChunkName: "docs" */'@/docs/Docs.vue');

import navTree from '@/content/pages/routes'
import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";

const devRoutes : RouteRecordRaw[] = []
if (process.env.GENERATE_DOCUMENTATION === 'true') {
  devRoutes.push({
    path: "/docs/:component?",
    component: Docs,
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...devRoutes,
    ...navTree
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                el: to.hash,
                behavior: 'smooth'
            })
        }, 1500)
      })
    }
  },
});

export default router
